import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Formik, Form } from 'formik';
import {
  TextField,
  SubmitButton,
  CancelPopupButton,
} from 'ui/FormElement';

import { useNavigate } from 'react-router-dom';
import routes from 'app/routes';

export default function Index({ category, onSave }) {
  const navigate = useNavigate();

  const FormSchema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
  });

  const formData = {
    title: category == null ? '' : category.attributes.title,
  };

  const openList = () => {
    navigate(routes.admin.resource_categories.index);
  };

  const onSubmit = (values, { setSubmitting }) => {
    onSave(values, () => {
      setSubmitting(false);
      openList();
    });
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <Form className="needs-validation" noValidate="">
          <TextField
            name="title"
            label={(
              <>
                <span>Title</span>
                <abbr title="required">*</abbr>
              </>
            )}
          />

          <div className="text-center mt50 mb30">
            <CancelPopupButton
              className="btn btn-primary btn-outline mr5 ml5 width-120"
              title="Cancel"
              onClick={openList}
            />
            <SubmitButton
              title={isSubmitting ? 'Please, wait ...' : 'Save'}
              disabled={isSubmitting}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
}

Index.propTypes = {
  category: PropTypes.object,
  onSave: PropTypes.func,
};

Index.defaultProps = {
  category: null,
  onSave: () => {},
};
